/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'link-create.unknown-error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
  'link-create.unknown-error.heading': 'Something went wrong.',
  'linkCreate.CreateConfluencePage.form.site.label': 'Site',
  'linkCreate.confirm-dismiss-dialog.modal.cancel-button-label': 'Go back',
  'linkCreate.confirm-dismiss-dialog.modal.confirm-button-label': 'Discard',
  'linkCreate.confirm-dismiss-dialog.modal.description': 'We won’t be able to save your information if you move away from this page.',
  'linkCreate.confirm-dismiss-dialog.modal.title': 'Your changes won’t be saved',
  'linkCreate.createForm.button.close': 'Close',
  'linkCreate.createForm.button.create': 'Create',
  'linkCreate.createForm.button.createAndOpen': 'Create + Open',
  'linkCreate.form.requiredField.instruction': 'Required fields are marked with an asterisk',
  'linkCreate.modal.heading': 'Create new'
};